import { render } from "./DepositSubmissionPreview.vue?vue&type=template&id=44f00905&scoped=true"
import script from "./DepositSubmissionPreview.vue?vue&type=script&lang=js"
export * from "./DepositSubmissionPreview.vue?vue&type=script&lang=js"

import "@/Common/Styles/depositSubmissionPreview.scss?vue&type=style&index=0&id=44f00905&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f00905"]])

export default __exports__